module.exports = __webpack_public_path__ + "472355e946955cd6a342625cb5338405.pdf";